/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * Routes Messages
 *
 * This contains all the text Routes to be displayed on the window's title.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  sampleApplication: {
    id: 'sampleApplication',
    defaultMessage: 'Sample of Apply for Benefits',
  },
  sampleApplicationOverview: {
    id: 'sampleApplicationOverview',
    defaultMessage: 'Sample of Apply for Benefits Overview',
  },
  sampleApplicationForm: {
    id: 'sampleApplicationForm',
    defaultMessage: 'Sample of Apply for Benefits Form',
  },
  sampleApplicationConfirmation: {
    id: 'sampleApplicationConfirmation',
    defaultMessage: 'Sample of Apply for Benefits Confirmation',
  },
});
